// TODO: Remover recplays legados

export const RecplayCategoriesEnum = {
	PROGRAM_OPENING: 'RECPLAY-CATEGORY-PROGRAM-OPENING',
	BLOCK_MIDDLE: 'RECPLAY-CATEGORY-BLOCK-MIDDLE',
	BREAK_IN: 'RECPLAY-CATEGORY-BREAK-IN',
	BREK_OUT: 'RECPLAY-CATEGORY-BREK-OUT',
	PROGRAM_CLOSING: 'RECPLAY-CATEGORY-PROGRAM-CLOSING',
};

export const RecplayCategoriesTranslationsEnum = {
	'RECPLAY-CATEGORY-PROGRAM-OPENING': 'RecPlay - Abertura do Programa',
	'RECPLAY-CATEGORY-BLOCK-MIDDLE': 'RecPlay - Meio de Bloco',
	'RECPLAY-CATEGORY-BREAK-IN': 'RecPlay - Ida Para o Intervalo',
	'RECPLAY-CATEGORY-BREK-OUT': 'RecPlay - Volta do Intervalo',
	'RECPLAY-CATEGORY-PROGRAM-CLOSING': 'RecPlay - Encerramento do Programa',
};

export const RecplayCategoriesColorsEnum = {
	'RECPLAY-CATEGORY-PROGRAM-OPENING': '#ff8f00',
	'RECPLAY-CATEGORY-BLOCK-MIDDLE': '#e59227',
	'RECPLAY-CATEGORY-BREAK-IN': '#d3ab34',
	'RECPLAY-CATEGORY-BREK-OUT': '#ddb94c',
	'RECPLAY-CATEGORY-PROGRAM-CLOSING': '#ab8e37',
};
